// extracted by mini-css-extract-plugin
export default {"section":"_7c1fa8fb012d6ffe","preview":"_4d8328d19189d001"};